import React from 'react';
import { Flame } from 'lucide-react';
import { cn } from '../../../ui';
import { streakMessage, weekIndexOf } from '../studentHomeRules';

const DAYS = [
  { short: 'M', name: 'Monday' }, { short: 'T', name: 'Tuesday' }, { short: 'W', name: 'Wednesday' },
  { short: 'T', name: 'Thursday' }, { short: 'F', name: 'Friday' }, { short: 'S', name: 'Saturday' },
  { short: 'S', name: 'Sunday' },
];

const StreakCard = ({ streak }) => {
  const today = streak.todayIndex ?? weekIndexOf();
  return (
    <section aria-label="Your streak" className="tw-cq-card tw-flex tw-min-w-0 tw-flex-col tw-justify-between tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-line tw-bg-surface-raised tw-p-3.5 tw-shadow-card page-sm:tw-p-4">
      <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-[0.6875rem] tw-uppercase tw-tracking-caps tw-text-content-subtle">
        <Flame size={14} aria-hidden="true" className="tw-text-chart-6" />
        Streak
      </div>
      <div className="tw-flex tw-items-baseline tw-gap-1.5">
        <span className="tw-text-[1.75rem] tw-font-extrabold tw-leading-none tw-text-chart-6">{streak.days}</span>
        <span className="tw-text-[0.8125rem] tw-font-medium tw-text-content-muted">{streak.days === 1 ? 'Day' : 'Days'}</span>
      </div>
      <p className="tw-m-0 tw-hidden tw-text-xs tw-text-content-muted card-xs:tw-block">{streakMessage(streak.days)}</p>
      <ul className="tw-m-0 tw-flex tw-list-none tw-justify-between tw-gap-1 tw-p-0">
        {DAYS.map((day, i) => {
          const active = !!streak.week?.[i];
          return (
            <li key={day.name} className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-gap-1">
              <span
                className={cn(
                  'tw-h-2 tw-w-2 tw-rounded-full',
                  active ? 'tw-bg-primary' : 'tw-bg-surface-sunken',
                  i === today && 'tw-ring-2 tw-ring-primary/30',
                )}
              />
              <span aria-hidden="true" className={cn('tw-text-[0.625rem] tw-font-semibold', i === today ? 'tw-text-primary' : 'tw-text-content-subtle')}>
                {day.short}
              </span>
              <span className="tw-sr-only">{day.name}: {active ? 'active' : 'not active'}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default StreakCard;
